module.exports = __webpack_public_path__ + "static/media/microphone_btn_grayscale.ca87f47a.png";